import { useState } from 'react';
import { AssetsPage, ConsumablesPage } from '@/modules/inventory';
import { useI18n } from '@/shared/i18n';

type Tab = 'assets' | 'consumables';

export const Inventory = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState<Tab>('assets');

  return (
    <div>
      {/* Tab Navigation */}
      <div className="border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex gap-4">
            <button
              onClick={() => setActiveTab('assets')}
              className={`py-3 px-1 border-b-2 transition-colors ${
                activeTab === 'assets'
                  ? 'border-primary-600 text-primary-600 font-medium'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              {t('inventory.assets')}
            </button>
            <button
              onClick={() => setActiveTab('consumables')}
              className={`py-3 px-1 border-b-2 transition-colors ${
                activeTab === 'consumables'
                  ? 'border-primary-600 text-primary-600 font-medium'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              {t('inventory.consumables')}
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'assets' && <AssetsPage />}
      {activeTab === 'consumables' && <ConsumablesPage />}
    </div>
  );
};
